export const AUTHORITY = 'authority';
export const LOGGED_IN_USER = 'logged_in_user';
export const ACTIVE_PROJECT_TAB = 'active_project_tab';
export const INVITE_TOKEN = 'token';
export const INVITE_WORKSPACE_NAME = 'workspacename';
export const SHOW_TIMELINE_PROMPT = 'show_timeline_prompt';
